import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["disabled", "onClick"];
const _hoisted_3 = { class: "desktop:flex mt-24 flex hidden justify-center" };
const _hoisted_4 = {
    key: 1,
    class: "desktop:hidden flex justify-center pt-20"
};
import { clsx } from 'clsx';
import { computed } from 'vue';
import { Badge, SpriteIcons, FilledButton, Pagination } from '@/user/components/common';
import { I18nInfo } from '@/user/models';
import { getBadgeColor, getBadgeText } from '@/user/models/common/level-badge';
import { examLabel, canAttend } from '@/user/models/certification/monthly-exam';
import { formatDate } from '@/user/helpers/util';
export default /*@__PURE__*/ _defineComponent({
    __name: 'List',
    props: {
        schedules: {
            type: Object,
        },
        type: {
            type: String,
            default: 'lecture',
        },
    },
    emits: ["itemClick", "pageChange", "loadMore"],
    setup(__props, { emit: __emit }) {
        const t = new I18nInfo('eduCenter.attend');
        const t_common = new I18nInfo('common');
        const props = __props;
        const emit = __emit;
        const contents = computed(() => props.schedules?.content || []);
        const currentPage = computed(() => props.schedules?.currentPage || 1);
        const totalPages = computed(() => props.schedules?.totalPages || 1);
        const hasNext = computed(() => props.schedules?.hasNext || false);
        const styles = {
            list: clsx('border-t-1 border-gray-900'),
            item: clsx('flex flex-col border-b-1 border-gray-200 py-20', 'desktop:flex-row desktop:flex-start desktop:items-center desktop:gap-0 desktop:border-gray-250 desktop:py-0'),
            levelArea: clsx('flex mb-8', 'desktop:w-120 desktop:justify-center desktop:mb-0'),
            utilArea: clsx('mt-16 order-3 flex items-center justify-between items-center gap-8', 'desktop:mt-0 desktop:order-0 desktop:w-98 desktop:gap-6'),
            utilOnOffline: clsx('flex items-center gap-4 text-gray-700 text-caption-1'),
            utilOnOfflineIcon: clsx('h-20 w-20 text-gray-600'),
            infoArea: clsx('flex flex-col gap-8 text-left select-text cursor-text', 'desktop:flex-1 desktop:py-18 desktop:px-20'),
            infoAreaHover: clsx('flex flex-col gap-8 group text-left', 'desktop:flex-1 desktop:py-18 desktop:px-20'),
            infoTitle: clsx('text-title-2 text-gray-900 desktop:line-clamp-1 line-clamp-2 group-hover:text-blue-70 desktop:text-title-4'),
            infoDate: clsx('text-m-body-1 flex items-center gap-4 text-gray-700 group-hover:text-blue-700'),
            infoDateIcon: clsx('hidden h-16 w-16 text-gray-400 group-hover:text-blue-700', 'desktop:block'),
            badgeArea: clsx('hidden', 'desktop:flex desktop:ml-auto desktop:w-100 desktop:items-center desktop:justify-center'),
            applyButtonArea: clsx('hidden', 'desktop:flex desktop:ml-auto desktop:w-100 desktop:items-center desktop:justify-center'),
            noItem: clsx('flex items-center justify-center border-b-1 border-gray-200 py-20', 'desktop:py-23'),
            noItemDsc: clsx('text-m-title-2 text-gray-900', 'desktop:text-title-4'),
        };
        function onPageChange(newPage) {
            emit('pageChange', newPage);
        }
        function handleItemClick(item) {
            emit('itemClick', item);
        }
        function handleLoadMore() {
            emit('loadMore');
        }
        function getStateText(item) {
            if (props.type === 'lecture') {
                return t_common.translate(`enums.state.${item.state}`);
            }
            return examLabel.state(item);
        }
        function getApplyButtonText(item) {
            if (props.type === 'lecture') {
                return canAttend(item.state)
                    ? t_common.translate('button.check')
                    : t_common.translate(`enums.state.${item.state}`);
            }
            return examLabel.apply(item);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("ul", {
                    class: _normalizeClass(styles.list)
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contents.value, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: item.id
                        }, [
                            _createElementVNode("div", {
                                class: _normalizeClass(styles.item)
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(styles.levelArea)
                                }, [
                                    _createVNode(_unref(Badge), {
                                        color: _unref(getBadgeColor)(item.level)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(getBadgeText)(item.level)), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["color"])
                                ], 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(styles.utilArea)
                                }, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(styles.utilOnOffline)
                                    }, [
                                        _createVNode(_unref(SpriteIcons), {
                                            name: item.method === 'ONLINE' ? 'online' : 'offline',
                                            class: _normalizeClass(styles.utilOnOfflineIcon)
                                        }, null, 8, ["name", "class"]),
                                        _createTextVNode(" " + _toDisplayString(_unref(t).translate(`eduType.${item.method}`)), 1)
                                    ], 2),
                                    _createVNode(_unref(FilledButton), {
                                        color: _unref(canAttend)(item.state) ? 'blue' : 'gray',
                                        disabled: !_unref(canAttend)(item.state) || (props.type === 'exam' && item.applied),
                                        "desktop-size": "large",
                                        "mobile-size": "medium",
                                        class: "desktop:hidden block",
                                        onClick: ($event) => (props.type === 'lecture' || (_unref(canAttend)(item.state) && !item.applied)
                                            ? handleItemClick(item)
                                            : undefined)
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(getApplyButtonText(item)), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["color", "disabled", "onClick"])
                                ], 2),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: _normalizeClass(props.type === 'lecture' ? styles.infoAreaHover : styles.infoArea),
                                    onClick: ($event) => (props.type === 'lecture' ? handleItemClick(item) : undefined)
                                }, [
                                    _createElementVNode("p", {
                                        class: _normalizeClass(styles.infoTitle)
                                    }, _toDisplayString(item.title), 3),
                                    _createElementVNode("span", {
                                        class: _normalizeClass(styles.infoDate)
                                    }, [
                                        _createVNode(_unref(SpriteIcons), {
                                            name: "time",
                                            class: _normalizeClass(styles.infoDateIcon),
                                            "aria-hidden": "true"
                                        }, null, 8, ["class"]),
                                        _createTextVNode(" " + _toDisplayString(_unref(formatDate)(item.startAt, item.finishAt)), 1)
                                    ], 2)
                                ], 10, _hoisted_1),
                                _createElementVNode("div", {
                                    class: _normalizeClass(styles.badgeArea)
                                }, [
                                    _createVNode(_unref(Badge), {
                                        color: _unref(canAttend)(item.state) ? 'blue' : 'gray',
                                        type: "outlined"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(getStateText(item)), 1)
                                        ]),
                                        _: 2
                                    }, 1032, ["color"])
                                ], 2),
                                (props.type === 'exam')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(styles.applyButtonArea)
                                    }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: _normalizeClass(["text-body-5 flex items-center gap-4", item.canApply ? 'text-blue-700' : 'text-gray-300']),
                                            disabled: !item.canApply,
                                            onClick: ($event) => (item.canApply ? handleItemClick(item) : undefined)
                                        }, [
                                            _createTextVNode(_toDisplayString(getApplyButtonText(item)) + " ", 1),
                                            (item.canApply)
                                                ? (_openBlock(), _createBlock(_unref(SpriteIcons), {
                                                    key: 0,
                                                    name: "line-arrow-right",
                                                    class: "h-16 w-16"
                                                }))
                                                : _createCommentVNode("", true)
                                        ], 10, _hoisted_2)
                                    ], 2))
                                    : _createCommentVNode("", true)
                            ], 2)
                        ]));
                    }), 128))
                ], 2),
                (contents.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(styles.noItem)
                    }, [
                        _createElementVNode("p", {
                            class: _normalizeClass(styles.noItemDsc)
                        }, _toDisplayString(props.type === 'exam'
                            ? _unref(t_common).translate('noExamData')
                            : _unref(t_common).translate('noLectureData')), 3)
                    ], 2))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(Pagination), {
                        class: "!text-title-4",
                        page: currentPage.value,
                        "total-pages": totalPages.value,
                        "onUpdate:page": onPageChange
                    }, null, 8, ["page", "total-pages"])
                ]),
                (hasNext.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_unref(FilledButton), {
                            color: "gray",
                            "desktop-size": "large",
                            "mobile-size": "medium",
                            "icon-name": "plus",
                            "icon-position": "right",
                            onClick: handleLoadMore
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t_common).translate('button.more')), 1)
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
